import { isObject } from '@scalar/helpers/object/is-object';
import { getResolvedRef, mergeSiblingReferences } from '@scalar/workspace-store/helpers/get-resolved-ref';
import { getExampleFromSchema } from '@scalar/workspace-store/request-example';
/** Preserve supplied values; generate a fallback only when examples are not supplied. */
export const getMarkdownExamples = (source, mediaType, mode, openapiVersion = '3.2.0') => {
    if (source.example !== undefined)
        return [{ value: source.example }];
    if (source.examples && Object.keys(source.examples).length) {
        return Object.entries(source.examples).flatMap(([name, reference]) => {
            const example = getResolvedRef(reference);
            if (!isObject(example))
                return [];
            const metadata = {
                name,
                summary: typeof example.summary === 'string' ? example.summary : undefined,
                description: typeof example.description === 'string' ? example.description : undefined,
            };
            if (example.value !== undefined)
                return [{ ...metadata, value: example.value }];
            if (/^3\.2\./.test(openapiVersion) && typeof example.serializedValue === 'string')
                return [{ ...metadata, serializedValue: example.serializedValue }];
            if (typeof example.externalValue === 'string')
                return [{ ...metadata, externalValue: example.externalValue }];
            if (/^3\.2\./.test(openapiVersion) && example.dataValue !== undefined)
                return [{ ...metadata, value: example.dataValue }];
            return [];
        });
    }
    const schema = getResolvedRef(source.schema);
    if (!isObject(schema))
        return [];
    const value = getExampleFromSchema(getResolvedRef(source.schema, mergeSiblingReferences), {
        xml: mediaType.includes('xml'),
        mode,
    });
    return value === undefined ? [] : [{ value }];
};
